import { Link } from "react-router-dom";

interface SectionHeadingProps {
  icon?: string;
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({
  icon,
  title,
  subtitle,
  moreTo,
  moreLabel = "查看更多",
}: SectionHeadingProps) {
  return (
    <div className="mb-5 flex items-end justify-between gap-4">
      <div className="flex items-center gap-3">
        <span className="flex h-9 w-1.5 rounded-full bg-accent-500" />
        <div>
          <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
            {icon && (
              <i className={`${icon} mr-2 text-primary-500`} aria-hidden="true" />
            )}
            {title}
          </h2>
          {subtitle && (
            <p className="mt-1 text-sm text-foreground-500">{subtitle}</p>
          )}
        </div>
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="group flex shrink-0 items-center gap-1 whitespace-nowrap text-sm font-medium text-foreground-600 transition-colors hover:text-primary-600"
        >
          {moreLabel}
          <i
            className="ri-arrow-right-s-line transition-transform group-hover:translate-x-0.5"
            aria-hidden="true"
          />
        </Link>
      )}
    </div>
  );
}